export const TIMEOUT = 3 * 1000; // 3s
export const RESULT_LIMIT = 5;
